import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20",
  class: "logout_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.5 5.667c0-1.4 0-2.1.272-2.635a2.5 2.5 0 0 1 1.093-1.093c.535-.272 1.235-.272 2.635-.272h2c1.4 0 2.1 0 2.635.272a2.5 2.5 0 0 1 1.092 1.093c.273.534.273 1.234.273 2.635v8.666c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.093c-.535.272-1.235.272-2.635.272h-2c-1.4 0-2.1 0-2.635-.272a2.5 2.5 0 0 1-1.093-1.093c-.272-.535-.272-1.235-.272-2.635v-3.5h4.167V9.167H7.5v-3.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.5 9.167H3.19l2.988-2.989L5 5l-5 5 5 5 1.178-1.179-2.988-2.988H7.5V9.167Z"
    }, null, -1)
  ]))]))
}
export default { render: render }